import { render, staticRenderFns } from "./HelpAskForHelp.vue?vue&type=template&id=97431d56&scoped=true&"
import script from "./HelpAskForHelp.vue?vue&type=script&lang=js&"
export * from "./HelpAskForHelp.vue?vue&type=script&lang=js&"
import style0 from "./HelpAskForHelp.vue?vue&type=style&index=0&id=97431d56&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97431d56",
  null
  
)

export default component.exports